import * as React from 'react';
import { enableRipple } from '@syncfusion/ej2-base';
import {
  ContextMenuComponent,
  TreeViewComponent,
} from '@syncfusion/ej2-react-navigations';
import {
  DialogComponent,
  ButtonPropsModel,
  AnimationSettingsModel,
} from '@syncfusion/ej2-react-popups';
import './style.css';
import {
  IoAddSharp,
  IoCheckmarkDoneOutline,
  IoRefresh,
  IoTrashOutline,
} from 'react-icons/io5';
import { GoPencil } from 'react-icons/go';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { toast } from 'react-toastify';
import Message from '../../utils/Message/Message';
import { all_information, loadingShow } from '../../App';
import { ThemeContext } from '../../context/theme.context';
import Scheduler from '../../components/GlobalScheduler';
import {
  getAssignments,
  getAssignmentsDetails,
} from '../../services/assignments/assignmentService';
import {
  createTeam,
  getTeams,
  getTeamsDetail,
  teamDelete,
  teamUpdate,
} from '../../services/TradePlanner/Team/TeamServices';
import { getTeamAssigments } from '../../services/tradeperson/team';
import GenerateCapacity from '../../utils/GenerateCapacity';
import { searchNodes } from '../../utils/GetFilterItems';
import { GetAssignmentOfTheTrade } from '../../services/TradePlanner/Trades/TradesServices';
import { assign, each, upperCase } from 'lodash';
import { connect } from 'react-redux';
import {
  setAssignments,
  setDefaultPairTrades,
  setDefaultTeams,
  setRefreshTeamComponent,
  setStoreTeam,
  setTeamDataChanged,
  setTrades,
} from '../../redux/search.slice';
import { RootState } from '../../store';
enableRipple(true);
interface IProps {
  setDefaultPairTrades: (a: string[]) => void;
  defaultPairTrades: string[];
  refreshTeamComponent: boolean;
  defaultAssignments: number[];
  storeTeam: string[];
  setRefreshTeamComponent: (a: boolean) => void;
  setDefaultTeams: (a: number[]) => void;
  setStoreTeam: (a: string[]) => void;
  setTeamDataChanged: (a: boolean) => void;
  setTrades: (a: Object[]) => void;
  setAssignments: (a: Object[]) => void;
  defaultTeams: number[];
}
interface HtmlAttributes {
  team_trade_id: string;
}
export interface DataSourceItem {
  id: number;
  pid: number;
  name: string;
  hasChild: boolean;
  description: string | null;
  team_id: number | null;
  trade_id: number | null;
  htmlAttributes: HtmlAttributes;
  name_description: string;
}

interface DataSource {
  dataSource: DataSourceItem[];
}

interface TeamInterface {
  hasChild: boolean | undefined;
  id: number | undefined;
  name: string | undefined;
  pid: string | undefined;
  team_id: number | undefined;
  trade_id: string | undefined;
}

type Fields = {
  dataSource: any;
  id: any;
  parentID: any;
  text: any;
  hasChildren: any;
  htmlAttributes: any;
};
interface IState {
  fields: Fields;
  hideDialogTeam: boolean;
  hideDialogDelete: boolean;
  hideDialogEdit: boolean;
  hideDialogAdd: boolean;
  teamsData: any;
  AssignmentData: any;
  selectedAssignments: Array<any>;
}
class Team extends React.Component<IProps, IState> {
  private allowDragAndDrop: boolean = true;
  private isChecked: boolean = true;
  private treeObj: any;
  public menuObjTeam: any;
  public menuItemsTeam: any;
  private buttonsTeamAdd: ButtonPropsModel[];
  private buttonsDelete: ButtonPropsModel[];
  private buttonsEdit: ButtonPropsModel[];
  private animationSettingsTeam: AnimationSettingsModel;
  public dialogInstanceTeam: any;
  public selectedNameTeam: string;
  private inputName: string = '';
  private inputDescription: string = '';
  private teamId: number = -1;
  checkedNodes: any[] = [];
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private assignmentId = -1;
  private current_team_trade_ids: Array<any> = [];
  private current_teams: Array<any> = [];
  private teamsFromBackend: [] = [];
  public teamtradeassignmentHieararchy: {
    dataSource: DataSourceItem[];
  } = {
    dataSource: [],
  };
  private CheckedBoxSelectedTeam: TeamInterface[] = [];
  private allFilteredAssignmentIds: Array<string> = [];
  constructor(props: IProps) {
    super(props);
    this.nodeChecked = this.nodeChecked.bind(this);
    this.handleSetTeam = this.handleSetTeam.bind(this);
    this.treeObj = new TreeViewComponent(props);
    this.menuObjTeam = new ContextMenuComponent(props);
    this.dialogInstanceTeam = new DialogComponent(props);
    this.selectedNameTeam = '';
    this.buttonsDelete = [
      {
        click: () => {
          this.deleteTeam();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsEdit = [
      {
        click: () => {
          this.editTeam();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogEdit: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttonsTeamAdd = [
      {
        click: () => {
          this.createTeam();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogAdd: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.animationSettingsTeam = { effect: 'Zoom', duration: 400, delay: 0 };
    this.menuItemsTeam = [
      {
        text: 'Assign Shift Element',
      },
    ];
    this.state = {
      teamsData: [],
      hideDialogEdit: false,
      hideDialogDelete: false,
      fields: {
        dataSource: [],
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
        htmlAttributes: 'htmlAttributes',
      },
      hideDialogTeam: false,
      hideDialogAdd: false,
      AssignmentData: [],
      selectedAssignments: [],
    };
  }
  handleSetTeam = (team: string[]) => {
    this.props.setStoreTeam(team);
  };
  handleStorageChange = (event: StorageEvent) => {
    // Local storage 'da belirli bir key değiştiğinde state'i güncelle
    if (event.key === 'defaultTeams') {
    }
  };
  componentDidMount() {
    this.getTeamsData();
    getTeams().then((result) => {
      this.teamsFromBackend = result.data.filter(
        (eachData: any) => eachData.pid == null
      );
      this.setState({ teamsData: result.data });
    });
  }
  filterTeamsByIds = (
    teamIds: number[],
    dataSource: DataSourceItem[]
  ): DataSourceItem[] => {
    const allItems = dataSource;

    const filteredTeams: DataSourceItem[] = allItems.filter((item) => {
      if (item.team_id !== null && teamIds.includes(item.team_id)) {
        return true;
      }
      let parentItem = allItems.find((parent) => parent.id === item.pid);
      while (parentItem) {
        if (
          parentItem.team_id !== null &&
          teamIds.includes(parentItem.team_id)
        ) {
          return true;
        }
        parentItem = allItems.find((parent) => parent.id === parentItem?.pid);
      }

      return false;
    });

    return filteredTeams;
  };
  stringToArray = (str: string): number[] => {
    let temp = [];
    temp = str.split(',');
    temp = temp.map((el) => parseInt(el));

    return temp;
  };
  findTradesAndAssignments = (Data: DataSourceItem[]) => {
    let assignmentIds: number[] = [];
    let tradeIds: number[] = [];
    console.log('Data', Data);
    var matchedItem: string[] = [];
    Data.forEach((el) => {
      var isUndefined = Data.find(
        (item) =>
          item.pid === el.id &&
          el.pid == null &&
          item.team_id === null &&
          item.trade_id == null
      );
      if (isUndefined !== undefined) {
        matchedItem.push(isUndefined.name);
      }

      if (el.team_id === null && el.id !== null) {
        assignmentIds.push(el.id);
      }

      if (el.trade_id !== null && el.pid !== null) {
        tradeIds.push(el.trade_id);
      }
    });
    console.log('matchedItem', matchedItem);
    // trade_id'yi benzersiz hale getirme
    tradeIds = Array.from(new Set(tradeIds));

    // assignment_id'yi benzersiz hale getirme
    assignmentIds = Array.from(new Set(assignmentIds));

    // Bu kısımda localStorage kullanımı ya da Redux state güncelleme yapılabilir
    localStorage.setItem('defaultTrades', tradeIds.toString());
    localStorage.setItem('defaultAssignments', assignmentIds.toString());

    // Redux store'a verileri dispatch et
    this.props.setDefaultPairTrades(matchedItem);
    this.props.setTrades(tradeIds);
    this.props.setAssignments(assignmentIds);
  };

  async componentDidUpdate(prevProps: IProps) {
    if (prevProps.defaultTeams !== this.props.defaultTeams) {
      var filteredTeams;
      if (
        this.props.defaultTeams != null &&
        this.props.defaultTeams != undefined &&
        this.props.defaultTeams.length > 0
      ) {
        filteredTeams = this.filterTeamsByIds(
          this.props.defaultTeams,
          this.teamtradeassignmentHieararchy.dataSource
        );
        this.findTradesAndAssignments(filteredTeams);
      } else {
        filteredTeams = this.teamtradeassignmentHieararchy.dataSource;
        this.props.setAssignments([]);
        this.props.setTrades([]);
      }
      this.setState({
        fields: {
          dataSource: filteredTeams,
          id: 'id',
          parentID: 'pid',
          text: 'name',
          hasChildren: 'hasChild',
          htmlAttributes: 'htmlAttributes',
        },
      });
    }
    if (prevProps.refreshTeamComponent !== this.props.refreshTeamComponent) {
      this.checkedNodes = [];
      this.props.setStoreTeam([]);
      this.treeObj.uncheckAll();
      await this.getTeamsData();

      this.props.setRefreshTeamComponent(false);
    }
    if (this.context.isDataChangeTeam) {
      this.getTeamsData();
      this.context.setDataChangeTeam(false);
    }
  }
  setTradeTeamAffected = () => {
    this.context.setDataChangeTrade(true);
    this.context.setDataChangeTeam(true);
    this.context.setDataChange(true);
  };
  private async getTeamsData() {
    this.teamsFromBackend = [];
    await getTeams().then((res) => {
      this.teamsFromBackend = res.data.filter(
        (eachData: any) => eachData.pid == null
      );
      var data = res.data.map((result: any) => {
        return {
          ...result,
          htmlAttributes: {
            team_trade_id: JSON.stringify([
              { team_id: result.team_id },
              { trade_id: result.trade_id },
              { assignment_id: result.id },
            ]),
          },
          name_description:
            result.description != null
              ? `${result.name} - ${result.description}`
              : result.name,
        };
      });

      var model = {
        dataSource: data,
        id: 'id',
        parentID: 'pid',
        text: 'name_description',
        hasChildren: 'hasChild',
        htmlAttributes: 'htmlAttributes',
      };
      this.teamtradeassignmentHieararchy = model;

      if (
        this.props.defaultTeams?.length > 0 &&
        this.props.defaultTeams != null &&
        this.props.defaultTeams != undefined
      ) {
        var filteredTeams;
        filteredTeams = this.filterTeamsByIds(
          this.props.defaultTeams,
          this.teamtradeassignmentHieararchy.dataSource
        );
        if (this.props.defaultTeams.length > 0) {
          this.findTradesAndAssignments(filteredTeams);
        }
      } else {
        filteredTeams = data;
      }

      this.setState({
        fields: {
          dataSource: filteredTeams,
          id: 'id',
          parentID: 'pid',
          text: 'name',
          hasChildren: 'hasChild',
          htmlAttributes: 'htmlAttributes',
        },
      });
    });
  }

  // public updateLocalStorageValue(newList: number[]) {
  //   const key = 'multiselectdeafaultTeams';

  //   const storedValue = localStorage.getItem(key);

  //   if (storedValue) {
  //     const parsedValue = JSON.parse(storedValue);

  //     parsedValue.value = newList;

  //     localStorage.setItem(key, JSON.stringify(parsedValue));
  //   } else {
  //     console.error(`${key} key'i localStorage'da bulunamadı.`);
  //   }
  // }
  private async deleteTeam() {
    if (this.CheckedBoxSelectedTeam.length == 0) {
      toast.error('Team was not selected be empty');
      loadingShow(false);
      return false;
    }
    // let obj = {
    //   team_id: teamID,
    // };
    let obj = this.CheckedBoxSelectedTeam.map((eachTeamObject) => {
      return eachTeamObject.team_id;
    });

    await teamDelete(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Deleted  successfully...');
        this.current_team_trade_ids[0] = null;

        var tempDefaultTeamList = this.props.defaultTeams;
        tempDefaultTeamList = tempDefaultTeamList.filter(
          (eachTeamId) => eachTeamId !== obj[0]
        );
        this.props.setDefaultTeams(tempDefaultTeamList);
        // this.updateLocalStorageValue(tempDefaultTeamList);
        // this.props.setTeamDataChanged(true);

        //xxxx
        //closed because after delete a team, this one send a get capacity request
        //this.context.setDataChangeTeam(true);
        //this.setTradeTeamAffected();

        this.getTeamsData();
      })
      .catch((err) => {
        console.log('error ', err);
        loadingShow(false);
        Message.error('Operation failed!!!');
      });
    this.dialogCloseDelete();
  }

  private editTeam() {
    var teamCode = this.inputName;
    var teamDescription = this.inputDescription;
    var teamID = this.teamId;
    if (teamCode === '') {
      toast.error('Team Name cannot be empty');
      loadingShow(false);
      return false;
    }
    if (teamDescription === '') {
      toast.error('Team Description cannot be empty');
      loadingShow(false);
      return false;
    }

    let obj = {
      team_code: teamCode,
      description: teamDescription,
      team_id: Number(teamID),
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      creation_date: new Date(),
    };
    teamUpdate(obj)
      .then((result) => {
        if (result.status === 200) {
          loadingShow(false);
          Message.success('Edited successfully...');
          this.getTeamsData();
          //closed because after edit a team, this one send a get capacity request
          //this.context.setDataChangeTeam(true);
        }
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Editing failed!!!');
      });

    this.dialogCloseEdit();
  }
  private dialogCloseDelete(): void {
    this.setState({
      hideDialogDelete: false,
    });
  }

  private dialogCloseEdit(): void {
    this.setState({
      hideDialogEdit: false,
    });
  }
  private dialogCloseTeamAdd(): void {
    this.setState({ hideDialogAdd: false });
  }
  private dialogOpenTeamAdd(): void {
    this.setState({ hideDialogAdd: true });
  }
  private menuclickTeam(argss: any) {
    //let targetNodeId = this.treeObj.selectedNodes[0];
    if (argss.item !== undefined) {
      if (argss.item.text === 'Assign Shift Element') {
        let theDatas = this.allFilteredAssignmentIds;

        if (theDatas.length > 0) {
          loadingShow(true, 'Preparing...');
          this.getAssignmentsData(theDatas);
          return;
        } else {
          Message.error(
            'This node not suitable to create any activity. There is no tradeperson here. Try another one.'
          );
          return;
        }
      } else if (argss.item.text === 'Teams Exception') {
      }
      // if (argss.item.text === 'Assign Shift Element') {
      //   let theDatas = this.current_team_trade_ids;
      //   loadingShow(true, 'Preparing...');
      //   if (theDatas[0].team_id === null && theDatas[1].trade_id === null) {
      //     this.getAssignmentsData(theDatas[2].assignment_id);
      //     return;
      //   }
      //   if (theDatas[1].trade_id !== null) {
      //     GetAssignmentOfTheTrade(theDatas[1].trade_id)
      //       .then((res) => {
      //         let theIds = [
      //           ...res.data.map((el: any) => el.assignment_id),
      //         ].toString();
      //         this.getAssignmentsData(theIds);
      //       })
      //       .catch((er) => {
      //         console.log('Error occured.Please try again later');
      //         loadingShow(false);
      //       });
      //     return;
      //   }
      //   if (theDatas[0].team_id === null && theDatas[1].trade_id === null) {
      //     Message.error(
      //       'This node not suitable to create any activity. Try another one.'
      //     );
      //     return;
      //   }
      //   if (theDatas[0].team_id === null) {
      //     Message.error(
      //       'This node not suitable to create any activity. Try another one.'
      //     );
      //     return;
      //   }
      //   let names: Array<string> = [];
      //   getTeamAssigments(theDatas[0].team_id)
      //     .then((res: any) => {
      //       let theIds = [
      //         ...res.data.map((el: any) => el.assignment_id),
      //       ].toString();
      //       if (theIds.length > 0) {
      //         this.getAssignmentsData(theIds);
      //       } else {
      //         loadingShow(false);
      //         Message.info('No Trade Person To Add Shift');
      //         return;
      //       }
      //     })
      //     .catch((er) => { });
      // } else if (argss.item.text === 'Teams Exception') {
      // }
    }
  }
  private getAssignmentsData = (theIds: string[]) => {
    getAssignmentsDetails(theIds)
      .then((el) => {
        loadingShow(false, 'Preparing...');
        this.activateCapacityGeneration(el.data);
      })
      .catch((e) => {
        loadingShow(false, 'Preparing...');
      });
  };
  private activateCapacityGeneration = (data: any) => {
    this.setState({
      selectedAssignments: data,
      hideDialogTeam: true,
    });
  };
  private nodeChecked(args: any) {
    var theTreeObj = this.treeObj as TreeViewComponent;
    var nodes = [...theTreeObj.getAllCheckedNodes()];
    this.handleSetTeam(nodes);
  }
  private AddTeamOpenModal = () => {
    this.dialogOpenTeamAdd();
  };
  private EditTeamOpenModal = async () => {
    var theTreeObj = this.treeObj as TreeViewComponent;

    let counter: number = 0;
    var checkednodes = theTreeObj.getAllCheckedNodes();
    var SelectedTeam: TeamInterface = {
      hasChild: false,
      id: 0,
      name: '',
      pid: '',
      team_id: undefined,
      trade_id: '',
    };
    this.teamsFromBackend.map((eachTeam: TeamInterface, index: number) => {
      checkednodes.map((eachnode) => {
        if (eachTeam.id && eachTeam.id.toString() == eachnode) {
          counter++;
          SelectedTeam = eachTeam;
        }
      });
    });

    if (counter != 1) {
      Message.info('Select 1 Team ');
      return;
    }
    if (SelectedTeam.team_id != undefined) {
      loadingShow(true, 'Preparing...');
      // let theDatas = this.current_team_trade_ids;

      if (SelectedTeam.team_id === null && SelectedTeam.trade_id === null) {
        Message.error(
          'This node not suitable to create any activity. Try another one.'
        );
        return;
      }
      if (SelectedTeam.team_id === null) {
        Message.error('This node not suitable to edit. Try another one.');
        return;
      }
      getTeamsDetail(SelectedTeam.team_id.toString())
        .then((e) => {
          loadingShow(false);
          this.teamId = e.data.team_id;
          this.inputName = e.data.team_code;
          this.inputDescription = e.data.description;
          this.setState({ hideDialogEdit: true });
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Error occured');
          //(e);
        });
    } else {
      Message.error('No selected any team to edit');
    }
  };
  private DeleteTeamOpenModal = async () => {
    let counter: number = 0;
    var theTreeObj = this.treeObj as TreeViewComponent;
    var checkednodes = theTreeObj.getAllCheckedNodes();
    this.CheckedBoxSelectedTeam = [];
    this.teamsFromBackend.map((eachTeam: TeamInterface, index: number) => {
      checkednodes.map((eachnode) => {
        if (eachTeam.id && eachTeam.id.toString() == eachnode) {
          counter++;
          this.CheckedBoxSelectedTeam.push(eachTeam);
        }
      });
    });
    if (this.CheckedBoxSelectedTeam.length > 0) {
      // this.teamId = SelectedTeam.team_id;
      this.setState({ hideDialogDelete: true });
    } else {
      Message.error('No selected any team to delete');
    }
  };
  private async createTeam() {
    var TeamCode = this.inputName;
    var teamDescription = this.inputDescription;

    if (TeamCode === '') {
      toast.error('Team Name cannot be empty');
      loadingShow(false);
      return false;
    }

    if (teamDescription === '') {
      toast.error('Team Description cannot be empty');
      loadingShow(false);
      return false;
    }

    loadingShow(true);

    try {
      const res = await getTeams();
      let teams: { name?: string; pid?: number }[] = res.data;

      const teamExists = teams.some(
        (eachteam) =>
          (eachteam.pid === null || eachteam.pid === undefined) &&
          eachteam.name?.toUpperCase() === TeamCode.toUpperCase()
      );

      if (teamExists) {
        Message.error('Same Team Already Exist');
        loadingShow(false);
        return false;
      }

      delete all_information.rowstamp;

      let obj = {
        team_code: TeamCode,
        description: teamDescription,
        app: 'UWORK',
        created_by: all_information.user_id,
        organization_id: all_information.company_id?.toString(),
        creation_date: new Date(),
      };

      await createTeam(obj).then(() => {
        this.props.setTeamDataChanged(true);
      });

      loadingShow(false);
      Message.success('Added successfully...');
      //closed because after create a team, this one send a get capacity request
      //this.context.setDataChangeTeam(true);
      this.getTeamsData();
    } catch (err) {
      loadingShow(false);
      Message.error('Add failed!!!');
      console.error(err);
    }

    this.dialogCloseTeamAdd();
  }

  private nodeclicked(args: any) {
    //get assignment ids in an simple way
    let data = this.treeObj.getAllCheckedNodes();
    let treedata = this.treeObj.getTreeData();
    let filteredData = treedata
      ?.filter((item: any) => item.hasChild === true)
      .map((item: any) => item.id);
    this.allFilteredAssignmentIds = data?.filter(
      (item: any) => !filteredData.includes(parseInt(item))
    );
    //

    const assignmentId2 = Number(args.node.getAttribute('data-uid'));
    this.current_team_trade_ids = JSON.parse(
      args.node.getAttribute('team_trade_id')
    );
    this.assignmentId = assignmentId2;

    let allAssignmentData: Array<any> = [];
    let allJustAssignmentId: Array<any> = [];
    if (this.assignmentId >= 100000 && this.assignmentId <= 199999) {
      const resultTrade = this.state.teamsData.filter((el: any) => {
        return el.pid === Number(this.assignmentId) && el.trade_id !== 0;
      });
      // TEAM Operations
      let resultTeam: Array<any> = this.state.teamsData.filter((el: any) => {
        return el.id === Number(this.assignmentId) && el.team_id !== null;
      });

      let checkedNodes: Array<any> = this.treeObj.getAllCheckedNodes();
      if (
        !this.treeObj
          .getAllCheckedNodes()
          .includes(this.assignmentId.toString())
      ) {
        resultTeam = checkedNodes.filter((item) => item === this.assignmentId);
      }
      resultTeam = checkedNodes.filter(
        (item) => item >= 100000 && item <= 199999 && item !== this.assignmentId
      );

      let teamAllDatas: Array<any> = [];
      resultTeam.map((id: any) => {
        for (var i = 0; i < this.state.teamsData.length; i++) {
          if (id === this.state.teamsData[i].id.toString()) {
            teamAllDatas.push(this.state.teamsData[i]);
          }
        }
      });
      this.current_teams = teamAllDatas;
      //
      resultTrade.map((elRes1: any) => {
        const resultAssignment = this.state.teamsData.filter((el: any) => {
          return el.pid === Number(elRes1.id);
        });
        allAssignmentData.push(...resultAssignment);
      });
    } else if (this.assignmentId >= 200000) {
      const resultTrade = this.state.teamsData.filter((el: any) => {
        return el.pid === Number(this.assignmentId) && el.trade_id !== 0;
      });
      allAssignmentData.push(...resultTrade);
    } else if (this.assignmentId < 100000) {
      allJustAssignmentId.push(this.assignmentId);
    }
    allAssignmentData.map((el) => {
      allJustAssignmentId.push(el.id);
    });
  }
  changeDataSource(data: any) {
    this.setState({
      fields: {
        dataSource: data,
        id: 'id',
        parentID: 'pid',
        text: 'name',
        hasChildren: 'hasChild',
        htmlAttributes: 'htmlAttributes',
      },
    });
  }
  searchNodes(args: any) {
    searchNodes(
      args.value,
      this.state.teamsData,
      this.changeDataSource.bind(this),
      'name',
      'id'
    );
  }
  render() {
    return (
      <div>
        <div className='teams-header-crud'>
          <h5 className='teams-baslik'>TEAMS</h5>
          <div className='team-crud'>
            <div className='add-team'>
              <IoAddSharp onClick={this.AddTeamOpenModal} size={17} />
            </div>
            <div className='edit-team'>
              <GoPencil onClick={() => this.EditTeamOpenModal()} size={17} />
            </div>
            <div className='delete-team'>
              <IoTrashOutline
                onClick={() => this.DeleteTeamOpenModal()}
                size={17}
              />
            </div>
            <div className='refresh-assignment'>
              <IoRefresh
                onClick={async () => {
                  toast.info('Team is refreshing...');

                  this.checkedNodes = [];
                  this.props.setStoreTeam([]);
                  this.treeObj.uncheckAll();
                  await this.getTeamsData();
                  toast.success('Team refreshed successfully...');
                  //closed because this one send a get capacity request
                  //this.context.setDataChangeTeam(false);
                }}
                size={17}
              />
            </div>
            <div className='uncheck-team'>
              <IoCheckmarkDoneOutline
                onClick={() => {
                  // this.checkedNodes = [];
                  // this.props.setStoreTeam([]);
                  this.treeObj.uncheckAll();
                }}
                size={17}
              />
            </div>
          </div>
        </div>
        <div className='searchAssign'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              alignSelf: 'flex-end',
              height: 25,
            }}
          >
            <TextBoxComponent
              type={'text'}
              id='team_search'
              autocomplete='off'
              // input={this.searchNodes.bind(this)}
              showClearButton
              placeholder='Search'
              onChange={this.searchNodes.bind(this)}
            />
            <div
              style={{
                borderRightColor: 'transparent',
                borderTopColor: 'transparent',
                borderBottomColor: 'transparent',
              }}
            ></div>
          </div>
        </div>
        <div id='treeTeamOverflow'>
          <TreeViewComponent
            id='treeTeam'
            fields={this.state.fields}
            ref={(treeview) => {
              this.treeObj = treeview;
            }}
            allowDragAndDrop={this.allowDragAndDrop}
            showCheckBox={this.isChecked}
            nodeChecked={this.nodeChecked}
            nodeClicked={this.nodeclicked.bind(this)}
            dragArea={document.getElementById('SplitterInner') as HTMLElement}
          />
          <ContextMenuComponent
            id='contentmenutree'
            target='#treeTeam'
            items={this.menuItemsTeam}
            select={this.menuclickTeam.bind(this)}
            ref={(contextmenuTeam) => {
              this.menuObjTeam = contextmenuTeam;
            }}
          />
          <div className='control-pane-dialog'>
            <div
              id='targetElement'
              className='col-lg-12 defaultDialog dialog-target'
            >
              {this.state.hideDialogTeam ? (
                <GenerateCapacity
                  assignments={this.state.selectedAssignments}
                  hideDialog={this.state.hideDialogTeam}
                  setHideDialogCapacity={(val) =>
                    this.setState({ hideDialogTeam: val })
                  }
                />
              ) : null}
            </div>
          </div>
          <div className='control-pane-dialogAdd'>
            <div
              id='targetElementAddTeam'
              className='col-lg-12 defaultDialogAddTeam dialog-target'
            >
              {this.state.hideDialogDelete ? (
                <DialogComponent
                  isModal={true}
                  id='defaultDialogDelete'
                  showCloseIcon={true}
                  animationSettings={this.animationSettingsTeam}
                  visible={this.state.hideDialogDelete}
                  header='Confirmation'
                  width={200}
                  height={'auto'}
                  buttons={this.buttonsDelete}
                  open={() => {
                    this.setState({ hideDialogDelete: true });
                  }}
                  close={() => {
                    this.setState({ hideDialogDelete: false });
                  }}
                >
                  <div className='container'>
                    <div className='row'>
                      <span>Do You Want To Delete This Team?</span>
                    </div>
                  </div>
                </DialogComponent>
              ) : null}

              {this.state.hideDialogEdit ? (
                <DialogComponent
                  isModal={true}
                  id='defaultDialogAddTeam'
                  showCloseIcon={true}
                  animationSettings={this.animationSettingsTeam}
                  visible={this.state.hideDialogEdit}
                  width={'400px'}
                  header='Team Editing'
                  buttons={this.buttonsEdit}
                  open={() => {
                    this.setState({ hideDialogEdit: true });
                  }}
                  close={() => {
                    this.setState({ hideDialogEdit: false });
                  }}
                >
                  <div className='row mb-3'>
                    <div className='col-md-3'>Team Name:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputName = e.value;
                        }}
                        value={this.inputName}
                        placeholder='Enter Name'
                      />
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-md-3'>Description:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputDescription = e.value;
                        }}
                        value={this.inputDescription}
                        placeholder='Enter Description'
                      />
                    </div>
                  </div>
                </DialogComponent>
              ) : null}

              {this.state.hideDialogAdd ? (
                <DialogComponent
                  isModal={true}
                  id='defaultDialogAddTeam'
                  showCloseIcon={true}
                  animationSettings={this.animationSettingsTeam}
                  visible={this.state.hideDialogAdd}
                  width={'400px'}
                  header='Team'
                  buttons={this.buttonsTeamAdd}
                  open={this.dialogOpenTeamAdd.bind(this)}
                  close={this.dialogCloseTeamAdd.bind(this)}
                >
                  <div className='row mb-3'>
                    <div className='col-md-3'>Team Name:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputName = e.value;
                        }}
                        placeholder='Enter Name'
                      />
                    </div>
                  </div>
                  <div className='row mb-3'>
                    <div className='col-md-3'>Description:</div>
                    <div className='col-md-9'>
                      <TextBoxComponent
                        input={(e) => {
                          this.inputDescription = e.value;
                        }}
                        placeholder='Enter Description'
                      />
                    </div>
                  </div>
                </DialogComponent>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state: RootState) => ({
  largeMode: state.search.largeMode,
  storeTeam: state.search.storeTeam,
  defaultTeams: state.search.defaultTeams,
  defaultAssignments: state.search.defaultAssignments,
  refreshTeamComponent: state.search.refreshTeamComponent,
  defaultPairTrades: state.search.defaultPairTrades,
});

const mapDispatchToProps = {
  setRefreshTeamComponent,
  setStoreTeam,
  setTrades,
  setAssignments,
  setTeamDataChanged,
  setDefaultTeams,
  setDefaultPairTrades,
};
export default connect(mapStateToProps, mapDispatchToProps)(Team);
